import React, {Component} from 'react';
import {withRouter, Route} from 'react-router-dom';
import {connect} from 'react-redux';


// styles
import style from '../../Styles/Containers/Home.module.css'
import * as Const from "../../Data/const";
import {parseUrlParameter} from "../../Lib/Utils";


class HomeContainer extends Component{
  constructor() {
    super();
  }

  componentDidMount() {
    const loginParams = {};

    const params = {
      client_id: Const.WEIBO.client_id,
      client_secret: Const.WEIBO.client_secret,
      redirect_uri: 'https://valid.mcheckplus.com/user',
      code: parseUrlParameter.parse(this.props.location.search).code,
      grant_type: 'authorization_code',
    }
/*

    const searchParams = Object.keys(params).map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');

    const jsonPromise = fetch('https://api.weibo.com/oauth2/access_token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body: searchParams
    }).then(async (response) => {
      return await response.json();
    })
*/
    /*const searchParams = Object.entries(params).map((entry) => {
      let [key, value] = entry;
      return encodeURIComponent(key) + '=' + encodeURIComponent(value);
    }).join('&');

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    fetch('https://api.weibo.com/oauth2/access_token',{
      method: 'POST',
      headers:myHeaders,
      body: searchParams
    }).then(async function(res){
      // 서버의 응답이 json인 경우 아래의 코드를 통해서 js의 객체로 변환된 결과를 얻을 수 있습니다.
      //console.log(await res.json());
      return await res.json();
    }).then((response) => {
      console.log('what is response', response);
      let data = response.data;
      this.props.dispatch(action.eUSER.login({ uid: 'weibo!' + data.uid, snsToken: data.access_token })).then((response) => {
        if (!response.user) throw new Error('No User');
        Const.showAlert('', response.user.name + '님 ' + Const.LOGIN_SUCCESS_MESSAGE);
        localStorage.setItem(Const.TOKEN['user'], response.token);
        localStorage.setItem(Const.LOGIN_TIME['user'], new Date());

        let loginValue = null
        if (response.user.email) {
          loginValue = response.user.email
        } else {
          let uidTypeAndId = response.user.uid.split('!');

          loginValue = uidTypeAndId[1];
        }
        Const.onLoginSuccess(response.token, loginValue);
        this.props.history.push(this.href);
      }).catch((err) => {
        Const.showAlert('', Const.LOGIN_WARNING_MESSAGE);
        this.props.history.push(this.href);
      });
      // 로그인 시작, loginParams에 uid와 토큰이 담겨있습니다.
    }).catch((err) => {
      console.log('json promise 2 ', err);
    })*/
  }


  render(){
    return(
      <div className={style.container} style={{height: window.innerHeight}}>
        <div className={style.logo}>
          <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/img-logo.svg"}></img>
        </div>
      </div>
    )
  }
}

export default connect()(withRouter(HomeContainer))